export const environment = {
  production: false,
  xdeBackendURL: 'https://dev.backend.xde.co.in'
};